import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { HttpClient } from '@angular/common/http';
import { map, take } from 'rxjs/operators';
import { FileSaverService } from 'ngx-filesaver';
import { Observable } from 'rxjs';
// Operations
import { GENERATE_ZIPPED_ANNEXES, GET_VISIT } from "./graphql/queries";
// Models
import { GraphqlNodeResponse, Visit } from 'inova-front-core/models';

@Injectable()
export class VisitApiService {
  constructor(private apollo: Apollo,
              private http: HttpClient,
              private fileSaverService: FileSaverService) {
  }

  generateZippedAnnexes(files: any, visitId: number) {
    return this.apollo.use('rep').watchQuery<any>({
      query: GENERATE_ZIPPED_ANNEXES,
      variables: { files, visitId }
    });
  }

  getVisit(id: string): Observable<Visit> {
    return this.apollo.watchQuery<GraphqlNodeResponse<Visit>>({
      query: GET_VISIT,
      fetchPolicy: 'network-only',
      variables: {ID: id}
    }).valueChanges.pipe(
      take(1),
      // @ts-ignore
      map(result => result.data[`visita`])
    );
  }

  downloadAnnexes(url: string, name: string | null = null): void {
    let ext = String(url.split('.').pop());
    if (ext.includes('?')) {
      ext = ext.split('?')[0];
    }
    console.log(url);
    console.log(name);
    if (name) {
      this.http.get(url, {responseType: 'blob'}).subscribe(res => {
        const blob = new Blob([res], {type: 'application/zip'});
        this.fileSaverService.save(blob, `${name}.${ext}`);
      });
    } else {
      this.http.get(url, {
        headers: {'Access-Control-Expose-Headers' : 'x-amz-meta-x-filename' },
        observe: 'response',
        responseType: 'blob'}
      ).subscribe((response: any) => {
        const blob = new Blob([response.body], { type: 'application/zip'});
        this.fileSaverService.save(blob, response.headers.get('x-amz-meta-x-filename'));
      });
    }
  }
}
